module.exports = __webpack_public_path__ + "static/media/navio_login.216dd572.png";